import { render, staticRenderFns } from "./completeProfile.vue?vue&type=template&id=0a6774e0"
import script from "./completeProfile.vue?vue&type=script&lang=js"
export * from "./completeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports